import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

/**
 * Convert a Date object to IST (Indian Standard Time) ISO 8601 format
 * IST is UTC+5:30
 */
export function toISTISOString(date: Date): string {
    // Create a formatter for IST timezone
    const formatter = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Asia/Kolkata',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    });
    
    // Get all parts
    const parts = formatter.formatToParts(date);
    
    const getValue = (type: string): string => {
        const part = parts.find(p => p.type === type);
        return part ? part.value.padStart(2, '0') : '00';
    };
    
    const year = getValue('year');
    const month = getValue('month');
    const day = getValue('day');
    const hour = getValue('hour');
    const minute = getValue('minute');
    const second = getValue('second');
    
    // Get milliseconds from the original date
    const milliseconds = String(date.getMilliseconds()).padStart(3, '0');
    
    // Format as ISO 8601 with IST offset (+05:30)
    return `${year}-${month}-${day}T${hour}:${minute}:${second}.${milliseconds}+05:30`;
}
